var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-audioguides",
                              title: _vm.getTitle
                                ? `${_vm.getTitle} аудиогид`
                                : `Создать аудиогид`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.$options.tabs, function (tab) {
                          return _c("v-tab", { key: tab.value }, [
                            _vm._v(" " + _vm._s(tab.title) + " "),
                          ])
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "PageContent",
                                        [
                                          _c("InputTitleSlug", {
                                            attrs: {
                                              "is-loading":
                                                _vm.loading || _vm.disabled,
                                              title: _vm.fields.title,
                                              "title-error":
                                                _vm.validationErrors.title,
                                              slug: _vm.fields.slug,
                                              isSlugEnabled: !_vm.isNew,
                                              "slug-error":
                                                _vm.validationErrors.slug,
                                            },
                                            on: {
                                              "change:title": function (
                                                $event
                                              ) {
                                                _vm.fields.title = $event
                                              },
                                              "change:slug": function ($event) {
                                                _vm.fields.slug = $event
                                              },
                                              "input:slug":
                                                _vm.$v.fields.slug.$touch,
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            [
                                              _c("QuillEditorVue", {
                                                attrs: {
                                                  cols: 12,
                                                  title: "Описание",
                                                  content:
                                                    _vm.fields.description,
                                                  isShowErrorMessage: true,
                                                  errorText:
                                                    _vm.validationErrors
                                                      .description,
                                                  loading: _vm.loading,
                                                  disabled: _vm.disabled,
                                                  "light-mode": "",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.fields.description =
                                                      $event
                                                  },
                                                  onChangeContent: function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "change:descriptionForMobile",
                                                      {
                                                        fields: _vm.fields,
                                                        $event,
                                                      }
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Изображения",
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value: _vm.fields.images,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.images =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("SeoSettings", {
                                                    attrs: {
                                                      data: _vm.data,
                                                      loading:
                                                        _vm.loading ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      "on-input-seo": function (
                                                        $event
                                                      ) {
                                                        _vm.fields =
                                                          Object.assign(
                                                            {},
                                                            _vm.fields,
                                                            $event
                                                          )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    [
                                      _c("DynamicListWrapper", {
                                        attrs: {
                                          "multiple-creating": false,
                                          list: _vm.fields.points,
                                          "error-messages":
                                            _vm.mixValidationErrors,
                                          "available-items":
                                            _vm.$options.availablePoints,
                                          "copy-clipboard":
                                            _vm.mixCopyListItemClipboard,
                                          options: _vm.$options.options,
                                        },
                                        on: {
                                          "list-sort": _vm.mixListItemsReassort,
                                          add: _vm.mixCreateListItemHandler,
                                          option: _vm.mixListItemOptionHandler,
                                          "option-manual":
                                            _vm.optionPointHandler,
                                          "change:descriptionForMobile":
                                            function ($event) {
                                              return _vm.changeDescriptionForMobileInPoint(
                                                $event
                                              )
                                            },
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item",
                                            fn: function ({ data }) {
                                              return [
                                                _c(data.item.type, {
                                                  tag: "component",
                                                  attrs: {
                                                    "list-item": data.item,
                                                    "error-messages":
                                                      _vm
                                                        .mixDynamicListValidationErrors[
                                                        data.itemIndex
                                                      ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.mixListItemChangeHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "change-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemChangeItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "remove-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemRemoveItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "published-at": _vm.data.publishedAt,
                      author: _vm.data.author ? _vm.data.author.name : "",
                      "is-loading": _vm.loading,
                      "is-submit-disabled": _vm.disabled,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "audioguide",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-audioguide")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-audioguides" })
                      },
                      submit: _vm.submit,
                      "update-translations": _vm.updateLanguages,
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "info-append",
                        fn: function () {
                          return [
                            _c("StatusPicker", {
                              attrs: {
                                align: "center",
                                cols: "12",
                                title: "Статус:",
                                disabled: _vm.loading,
                                loading: _vm.loading,
                                status: _vm.fields.status,
                              },
                              on: {
                                "status:change": function ($event) {
                                  _vm.fields.status = $event
                                },
                              },
                            }),
                            !_vm.isNew
                              ? _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [
                                        _vm._v("Посмотреть на сайте"),
                                      ]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              link: "",
                                              color: "primary",
                                              target: "_blank",
                                              href: _vm.redirerectToWebPortal,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("mdi-web")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c(
                              "v-card",
                              { attrs: { flat: "" } },
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "grey--text" },
                                  [_vm._v(" Связи")]
                                ),
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c("Organizer", {
                                          attrs: {
                                            profileType: _vm.fields.profileType,
                                            profileId: _vm.fields.profileId,
                                            profileTypeError:
                                              _vm.validationErrors.profileType,
                                            loading: _vm.loading,
                                            disabled: _vm.disabled,
                                            allowedProfilesProps: [
                                              "GUIDE",
                                              "TOURIST_AGENCY",
                                            ],
                                          },
                                          on: {
                                            "input:profile-type": function (
                                              $event
                                            ) {
                                              _vm.fields.profileType = $event
                                            },
                                            "input:profile-id": function (
                                              $event
                                            ) {
                                              _vm.fields.profileId = $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        !!_vm.cities
                                          ? _c(
                                              "v-col",
                                              [
                                                _c("span", [_vm._v("Город")]),
                                                _c("v-select", {
                                                  attrs: {
                                                    dense: "",
                                                    outlined: "",
                                                    "no-data-text":
                                                      "Список пуст",
                                                    "item-value": "id",
                                                    "item-text": "title",
                                                    clearable: "",
                                                    loading: _vm.loading,
                                                    disabled: _vm.disabled,
                                                    value: _vm.fields.cityId,
                                                    items: _vm.cities,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      _vm.fields.cityId = $event
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [
                                              _vm._v("Виды передвижения*"),
                                            ]),
                                            _c("v-select", {
                                              attrs: {
                                                dense: "",
                                                outlined: "",
                                                "no-data-text": "Список пуст",
                                                "item-value": "id",
                                                "item-text": "label",
                                                id: "modes",
                                                multiple: "",
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                                "error-messages":
                                                  _vm.validationErrors.modes,
                                                value: _vm.fields.modes,
                                                items:
                                                  _vm.dictionariesTypes
                                                    .audioguideMode,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.fields.modes = $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [
                                              _vm._v("Категории аудиогида*"),
                                            ]),
                                            _c("v-select", {
                                              attrs: {
                                                dense: "",
                                                outlined: "",
                                                id: "categories",
                                                "no-data-text": "Список пуст",
                                                "item-value": "id",
                                                "item-text": "label",
                                                multiple: "",
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                                "error-messages":
                                                  _vm.validationErrors
                                                    .categories,
                                                value: _vm.fields.categories,
                                                items:
                                                  _vm.dictionariesTypes
                                                    .audioguideCategory,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.fields.categories = $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }